const normalizeEmail = (value) => {
    if (value == null || typeof value !== "string") return value;
    return value.trim().replace(/\s+/g, "").toLowerCase();
};

export { normalizeEmail };
export default normalizeEmail;
